import { render, staticRenderFns } from "./adminMedication.vue?vue&type=template&id=6c5d178a&scoped=true"
import script from "./adminMedication.vue?vue&type=script&lang=js"
export * from "./adminMedication.vue?vue&type=script&lang=js"
import style0 from "./adminMedication.vue?vue&type=style&index=0&id=6c5d178a&prod&lang=css"
import style1 from "./adminMedication.vue?vue&type=style&index=1&id=6c5d178a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d178a",
  null
  
)

export default component.exports